import { useState } from 'react';

import { creditCard } from '~/components/payment/deposit/data/validate';
import { Translations } from '~/components/payment/quick-deposit-beta/components-v2/types';
import { LOADING, textKeysQDAmountScreen } from '~/components/payment/quick-deposit-beta/utils/constants';

import { PaymentButtonSecondary, StyledCVVInput } from './styles';

type Props = {
	executeQDDeposit: ({ cvv }: { cvv: string }) => void;
	translation: Translations<typeof textKeysQDAmountScreen>;
	views: string[];
};

const NewQDCVVscreen = ({ translation: t, views, executeQDDeposit }: Props) => {
	const [cvv, setCVV] = useState('');

	const setCVVandExecute = () => {
		executeQDDeposit({ cvv });
	};

	return (
		<>
			<StyledCVVInput
				autoFocus
				automationClass=""
				className="new-quick-deposit-cvv-wrapper"
				data-map="phone"
				disabled={views.includes(LOADING)}
				id="CVVInput"
				onChange={event => setCVV(event.target?.value)}
				placeholder={t.QD_CVV_INPUT}
				type="tel"
				value={cvv}
			/>
			<PaymentButtonSecondary
				smallfont
				disabled={!creditCard.cc.isAccepted(cvv) || views.includes(LOADING)}
				onClick={setCVVandExecute}
				type="submit"
				className="button u-mb1 u-mt1"
				title="title"
				dataAt="new-mobile-quick-deposit-button"
			>
				{t.QD_CVV_CONTINUE}
			</PaymentButtonSecondary>
		</>
	);
};

export default NewQDCVVscreen;
